import '../scss/main.scss';

import $ from 'jquery';
import whatInput from "what-input";
import 'lazysizes';


import {Scroll} from "./includes/scroll";
import {ToggleDrawer} from "./includes/toggle_drawer";

whatInput.ask("intent");


$(() => {
  Scroll();
  ToggleDrawer();
})
